export default __webpack_public_path__ + "static/media/logo.86558a73.svg";